<div class="h-100" style="margin-left: -0.75rem !important; margin-right: -0.75rem !important;">
    <h2 class="text-center">Votre photo</h2>
    <img [src]="LocalImageURL" [width]="PhotoWidth" />
</div>